export default class CACA1030RequestModel {
  productIndexLst: [
    {
      productNo: string
      shhnCd: string
      productNameInformal: string
    }
  ]
}
